<div class="gantt-chart-wrapper flex flex-col gap-3">
    @if (isToolbarVisible) {
        <div
            class="flex w-full flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2"
            role="toolbar"
        >
            @if (mergedConfig.allowExpansion && hasExpandableItems) {
                <button
                    type="button"
                    class="btn btn-sm btn-white inline-flex items-center justify-center gap-2"
                    [attr.aria-label]="expandAllLabelKey | translate"
                    (click)="toggleExpandAll()"
                >
                    <i
                        class="fa-light flex-shrink-0"
                        [ngClass]="
                            isAllExpanded ? 'fa-chevron-up' : 'fa-chevron-down'
                        "
                        aria-hidden="true"
                    ></i>
                    <span
                        class="hidden sm:inline-block sm:min-w-[6.5rem] sm:text-center"
                    >
                        {{ expandAllLabelKey | translate }}
                    </span>
                </button>
            }
            @if (pdfExportName) {
                <div class="ms-auto flex-shrink-0">
                    <app-export-pdf
                        [getElementReferences]="getGanttElementForExport"
                        [pdfName]="pdfExportName"
                    ></app-export-pdf>
                </div>
            }
        </div>
    }
    @if (processedData && processedData.length > 0 && !isLoading) {
        <div
            #ganttContainer
            class="gantt-container overflow-x-auto rounded-xl border border-slate-200"
            role="grid"
            [attr.aria-label]="
                (title ? 'translate_gantt_chart_for' : 'translate_gantt_chart')
                    | translate: { title: title }
            "
            [attr.aria-rowcount]="visibleRows.length + 1"
            [attr.aria-colcount]="displayMonths.length + 1"
        >
            <div class="flex w-full flex-col">
                <app-gantt-header
                    [title]="title"
                    [progress]="progress"
                    [startDate]="adjustedStartDate"
                    [endDate]="adjustedEndDate"
                    [displayMonths]="displayMonths"
                ></app-gantt-header>
                @for (
                    row of visibleRows;
                    track trackByVisibleRow($index, row)
                ) {
                    <app-gantt-task-row
                        [item]="row.item"
                        [depth]="row.depth"
                        [config]="mergedConfig"
                        [taskPosition]="row.taskPosition"
                        [isExpanded]="row.isExpanded"
                        [hasChildren]="row.hasChildren"
                        [displayDatesLength]="displayDates.length"
                        [taskTemplate]="taskTemplate"
                        [subtaskTemplate]="subtaskTemplate"
                        (taskClick)="onTaskClick($event)"
                        (toggleTask)="toggleTask($event)"
                    ></app-gantt-task-row>
                }
            </div>
        </div>
    }
    @if (isLoading) {
        <div
            class="flex min-h-[200px] items-center justify-center rounded-xl border border-slate-200 bg-white p-8"
            role="status"
            aria-live="polite"
        >
            <div class="flex items-center gap-3">
                <div
                    class="h-6 w-6 animate-spin rounded-full border-2 border-slate-200 border-t-primary-600"
                ></div>
                <span class="text-slate-600"
                    >{{ 'translate_loading' | translate }}...</span
                >
            </div>
        </div>
    }
    @if (!isLoading && (!processedData || processedData.length === 0)) {
        <div
            class="flex min-h-[200px] flex-col items-center justify-center rounded-xl border border-slate-200 bg-white py-12 text-center"
            role="status"
            aria-live="polite"
        >
            <div
                class="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-slate-100"
            >
                <i
                    class="fa-light fa-calendar-xmark text-2xl text-slate-400"
                ></i>
            </div>
            <p class="text-slate-600">
                {{ 'translate_could_not_find_any_items' | translate }}
            </p>
        </div>
    }
</div>
